import "../assets/index-2e5e3b55.css";
import S from "../Components/NcActions.mjs";
import g from "../Components/NcActionLink.mjs";
import y from "../Components/NcButton.mjs";
import U from "../Components/NcLoadingIcon.mjs";
import d from "../Functions/usernameToColor.mjs";
import "../Composables/useIsFullscreen.mjs";
import "../Composables/useIsMobile.mjs";
import { generateOcsUrl as _, generateUrl as c } from "@nextcloud/router";
/* empty css                                                                           */import { n as b } from "./_plugin-vue2_normalizer-71e2aa87.mjs";
import "linkify-string";
import "escape-html";
import "striptags";
import "vue";
import { getCurrentUser as l } from "@nextcloud/auth";
import f from "@nextcloud/axios";
import { getCapabilities as M } from "@nextcloud/capabilities";
import { t as i } from "./l10n-1b905a9a.mjs";
import { D as N } from "./DotsHorizontal-0ee7d901.mjs";
import { subscribe as o, unsubscribe as u } from "@nextcloud/event-bus";
import { getBuilder as w } from "@nextcloud/browser-storage";
import { vOnClickOutside as x } from "@vueuse/components";
/**
 * @copyright Copyright (c) 2020 Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const A = {
  data() {
    return {
      hasStatus: !1,
      userStatus: {
        status: null,
        message: null,
        icon: null
      }
    };
  },
  methods: {
    /**
     * Fetches the user-status from the server
     *
     * @param {string} userId UserId of the user to fetch the status for
     *
     * @return {Promise<void>}
     */
    async fetchUserStatus(s) {
      var e, a;
      if (!s)
        return;
      const t = M();
      if (!(!Object.prototype.hasOwnProperty.call(t, "user_status") || !t.user_status.enabled) && l())
        try {
          const { data: r } = await f.get(_("apps/user_status/api/v1/statuses/{userId}", { userId: s })), {
            status: n,
            message: m,
            icon: v
          } = r.ocs.data;
          this.userStatus.status = n, this.userStatus.message = m || "", this.userStatus.icon = v || "", this.hasStatus = !0;
        } catch (r) {
          if (r.response.status === 404 && ((a = (e = r.response.data.ocs) == null ? void 0 : e.data) == null ? void 0 : a.length) === 0)
            return;
          console.error(r);
        }
    }
  }
};
const p = w("nextcloud").persist().build();
function L(s) {
  const t = p.getItem("user-has-avatar." + s);
  return typeof t == "string" ? !!t : null;
}
function h(s, t) {
  s && p.setItem("user-has-avatar." + s, t);
}
const C = {
  name: "NcAvatar",
  directives: {
    ClickOutside: x
  },
  components: {
    DotsHorizontal: N,
    NcActions: S,
    NcActionLink: g,
    NcButton: y,
    NcLoadingIcon: U
  },
  mixins: [A],
  props: {
    /**
     * Set a custom url to the avatar image
     * either the url, user or displayName property must be defined
     */
    url: {
      type: String,
      default: void 0
    },
    /**
     * Set a css icon-class for an icon to be used instead of the avatar.
     */
    iconClass: {
      type: String,
      default: void 0
    },
    /**
     * Set the user id to fetch the avatar
     * either the url, user or displayName property must be defined
     */
    user: {
      type: String,
      default: void 0
    },
    /**
     * Whether or not to display the user-status
     */
    showUserStatus: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether or not to the status-icon should be used instead of online/away
     */
    showUserStatusCompact: {
      type: Boolean,
      default: !0
    },
    /**
     * When the user status was preloaded via another source it can be handed in with this property to save the request.
     * If this property is not set the status will be fetched automatically.
     * If a preloaded no-status is available provide this object with properties "status", "icon" and "message" set to null.
     */
    preloadedUserStatus: {
      type: Object,
      default: void 0
    },
    /**
     * Is the user a guest user (then we have to user a different endpoint)
     */
    isGuest: {
      type: Boolean,
      default: !1
    },
    /**
     * Set a display name that will be rendered as a tooltip
     * either the url, user or displayName property must be defined
     * specify just the displayname to generate a placeholder avatar without
     * trying to fetch the avatar based on the user id
     */
    displayName: {
      type: String,
      default: void 0
    },
    /**
     * Set a size in px for the rendered avatar
     */
    size: {
      type: Number,
      default: 32
    },
    /**
     * Placeholder avatars will be automatically generated when this is set to true
     */
    allowPlaceholder: {
      type: Boolean,
      default: !0
    },
    /**
     * Disable the tooltip
     */
    disableTooltip: {
      type: Boolean,
      default: !1
    },
    /**
     * Disable the menu
     */
    disableMenu: {
      type: Boolean,
      default: !1
    },
    /**
     * Declares a custom tooltip when not null
     * Fallback will be the displayName
     *
     * requires disableTooltip not to be set to true
     */
    tooltipMessage: {
      type: String,
      default: null
    },
    /**
     * Declares username is not a user's name, when true.
     * Prevents loading user's avatar from server and forces generating colored initials,
     * i.e. if the user is a group
     */
    isNoUser: {
      type: Boolean,
      default: !1
    },
    /**
     * Selector for the popover menu container
     */
    menuContainer: {
      type: [String, Object, Element, Boolean],
      default: "body"
    }
  },
  data() {
    return {
      avatarUrlLoaded: null,
      avatarSrcSetLoaded: null,
      userDoesNotExist: !1,
      isAvatarLoaded: !1,
      isMenuLoaded: !1,
      contactsMenuLoading: !1,
      contactsMenuActions: [],
      contactsMenuOpenState: !1
    };
  },
  computed: {
    avatarAriaLabel() {
      var s, t;
      if (this.hasMenu)
        return this.canDisplayUserStatus || this.showUserStatusIconOnAvatar ? i("Avatar of {displayName}, {status}", { displayName: (s = this.displayName) != null ? s : this.user, status: this.userStatusText }) : i("Avatar of {displayName}", { displayName: (t = this.displayName) != null ? t : this.user });
    },
    /** Translated current user status */
    userStatusText() {
      switch (this.userStatus.status) {
        case "away":
          return i("away");
        case "dnd":
          return i("do not disturb");
        case "online":
          return i("online");
        case "offline":
          return i("offline");
        default:
          return this.userStatus.status;
      }
    },
    /**
     * If the avatar has no menu no aria-label is assigned, but for accessibility we still need the status to be accessible
     * So this sets `role=img` on the status indicator (span with background) and the required `alt` and `aria-label` attributes.
     */
    userStatusRole() {
      return this.hasMenu ? void 0 : {
        role: "img",
        "aria-label": i("User status: {status}", { status: this.userStatusText })
      };
    },
    canDisplayUserStatus() {
      return this.showUserStatus && this.hasStatus && ["online", "away", "dnd"].includes(this.userStatus.status);
    },
    showUserStatusIconOnAvatar() {
      return this.showUserStatus && this.showUserStatusCompact && this.hasStatus && this.userStatus.status !== "dnd" && this.userStatus.icon;
    },
    /**
     * The user identifier, either the display name if set or the user property
     * If both properties are not set an empty string is returned
     */
    userIdentifier() {
      return this.isDisplayNameDefined ? this.displayName : this.isUserDefined ? this.user : "";
    },
    isUserDefined() {
      return typeof this.user < "u";
    },
    isDisplayNameDefined() {
      return typeof this.displayName < "u";
    },
    isUrlDefined() {
      return typeof this.url < "u";
    },
    hasMenu() {
      var s;
      return this.disableMenu ? !1 : this.isMenuLoaded ? this.menu.length > 0 : !(this.user === ((s = l()) == null ? void 0 : s.uid) || this.userDoesNotExist || this.url);
    },
    /**
     * True if initials should be shown as the user icon fallback
     */
    showInitials() {
      return this.allowPlaceholder && this.userDoesNotExist && !(this.iconClass || this.$slots.icon);
    },
    avatarStyle() {
      return {
        "--size": this.size + "px",
        lineHeight: this.size + "px",
        fontSize: Math.round(this.size * 0.45) + "px"
      };
    },
    initialsWrapperStyle() {
      const { r: s, g: t, b: e } = d(this.userIdentifier);
      return {
        backgroundColor: `rgba(${s}, ${t}, ${e}, 0.1)`
      };
    },
    initialsStyle() {
      const { r: s, g: t, b: e } = d(this.userIdentifier);
      return {
        color: `rgb(${s}, ${t}, ${e})`
      };
    },
    tooltip() {
      return this.disableTooltip ? !1 : this.tooltipMessage ? this.tooltipMessage : this.displayName;
    },
    /**
     * Get the (max. two) initials of the user as uppcase string
     */
    initials() {
      let s = "?";
      if (this.showInitials) {
        const t = this.userIdentifier.trim();
        if (t === "")
          return "?";
        const e = t.match(/[\p{L}\p{N}\s]/gu).join(""), a = e.lastIndexOf(" ");
        s = String.fromCodePoint(e.codePointAt(0)), a !== -1 && (s = s.concat(String.fromCodePoint(e.codePointAt(a + 1))));
      }
      return s.toLocaleUpperCase();
    },
    menu() {
      const s = this.contactsMenuActions.map((e) => ({
        href: e.hyperlink,
        icon: e.icon,
        text: e.title
      }));
      function t(e) {
        const a = document.createTextNode(e), r = document.createElement("p");
        return r.appendChild(a), r.innerHTML;
      }
      return this.showUserStatus && (this.userStatus.icon || this.userStatus.message) ? [{
        href: "#",
        icon: `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><text x='0' y='14' font-size='14'>${t(this.userStatus.icon)}</text></svg>`,
        text: `${this.userStatus.message}`
      }].concat(s) : s;
    }
  },
  watch: {
    url() {
      this.userDoesNotExist = !1, this.loadAvatarUrl();
    },
    user() {
      this.userDoesNotExist = !1, this.isMenuLoaded = !1, this.loadAvatarUrl();
    }
  },
  mounted() {
    this.loadAvatarUrl(), o("settings:avatar:updated", this.loadAvatarUrl), o("settings:display-name:updated", this.loadAvatarUrl), this.showUserStatus && this.user && !this.isNoUser && (this.preloadedUserStatus ? (this.userStatus.status = this.preloadedUserStatus.status || "", this.userStatus.message = this.preloadedUserStatus.message || "", this.userStatus.icon = this.preloadedUserStatus.icon || "", this.hasStatus = this.preloadedUserStatus.status !== null) : this.fetchUserStatus(this.user), o("user_status:status.updated", this.handleUserStatusUpdated));
  },
  beforeDestroy() {
    u("settings:avatar:updated", this.loadAvatarUrl), u("settings:display-name:updated", this.loadAvatarUrl), this.showUserStatus && this.user && !this.isNoUser && u("user_status:status.updated", this.handleUserStatusUpdated);
  },
  methods: {
    t: i,
    handleUserStatusUpdated(s) {
      this.user === s.userId && (this.userStatus = {
        status: s.status,
        icon: s.icon,
        message: s.message
      });
    },
    /**
     * Toggle the popover menu on click or enter
     * @param {KeyboardEvent|MouseEvent} event the UI event
     */
    async toggleMenu(s) {
      s.type === "keydown" && s.key !== "Enter" || (this.contactsMenuOpenState || await this.fetchContactsMenu(), this.contactsMenuOpenState = !this.contactsMenuOpenState);
    },
    closeMenu() {
      this.contactsMenuOpenState = !1;
    },
    async fetchContactsMenu() {
      this.contactsMenuLoading = !0;
      try {
        const s = encodeURIComponent(this.user), { data: t } = await f.post(c("contactsmenu/findOne"), `shareType=0&shareWith=${s}`);
        this.contactsMenuActions = t.topAction ? [t.topAction].concat(t.actions) : t.actions;
      } catch {
        this.contactsMenuOpenState = !1;
      }
      this.contactsMenuLoading = !1, this.isMenuLoaded = !0;
    },
    /**
     * Handle avatar loading if user or url defined
     */
    loadAvatarUrl() {
      if (this.isAvatarLoaded = !1, !this.isUrlDefined && (!this.isUserDefined || this.isNoUser)) {
        this.isAvatarLoaded = !0, this.userDoesNotExist = !0;
        return;
      }
      if (this.isUrlDefined) {
        this.updateImageIfValid(this.url);
        return;
      }
      if (this.size <= 64) {
        const s = this.avatarUrlGenerator(this.user, 64), t = [
          s + " 1x",
          this.avatarUrlGenerator(this.user, 512) + " 8x"
        ].join(", ");
        this.updateImageIfValid(s, t);
      } else {
        const s = this.avatarUrlGenerator(this.user, 512);
        this.updateImageIfValid(s);
      }
    },
    /**
     * Generate an avatar url from the server's avatar endpoint
     *
     * @param {string} user the user id
     * @param {number} size the desired size
     * @return {string}
     */
    avatarUrlGenerator(s, t) {
      var n;
      const e = window.getComputedStyle(document.body).getPropertyValue("--background-invert-if-dark") === "invert(100%)";
      let a = "/avatar/{user}/{size}" + (e ? "/dark" : "");
      this.isGuest && (a = "/avatar/guest/{user}/{size}" + (e ? "/dark" : ""));
      let r = c(
        a,
        {
          user: s,
          size: t
        }
      );
      return s === ((n = l()) == null ? void 0 : n.uid) && typeof oc_userconfig < "u" && (r += "?v=" + oc_userconfig.avatar.version), r;
    },
    /**
     * Check if the provided url is valid and update Avatar if so
     *
     * @param {string} url the avatar url
     * @param {Array} srcset the avatar srcset
     */
    updateImageIfValid(s, t = null) {
      const e = L(this.user);
      if (this.isUserDefined && typeof e == "boolean") {
        this.isAvatarLoaded = !0, this.avatarUrlLoaded = s, t && (this.avatarSrcSetLoaded = t), e === !1 && (this.userDoesNotExist = !0);
        return;
      }
      const a = new Image();
      a.onload = () => {
        this.avatarUrlLoaded = s, t && (this.avatarSrcSetLoaded = t), this.isAvatarLoaded = !0, h(this.user, !0);
      }, a.onerror = () => {
        console.debug("Invalid avatar url", s), this.avatarUrlLoaded = null, this.avatarSrcSetLoaded = null, this.userDoesNotExist = !0, this.isAvatarLoaded = !1, h(this.user, !1);
      }, t && (a.srcset = t), a.src = s;
    }
  }
};
var D = function() {
  var t = this, e = t._self._c;
  return e("span", t._g({ directives: [{ name: "click-outside", rawName: "v-click-outside", value: t.closeMenu, expression: "closeMenu" }], ref: "main", staticClass: "avatardiv popovermenu-wrapper", class: {
    "avatardiv--unknown": t.userDoesNotExist,
    "avatardiv--with-menu": t.hasMenu,
    "avatardiv--with-menu-loading": t.contactsMenuLoading
  }, style: t.avatarStyle, attrs: { title: t.tooltip, tabindex: t.hasMenu ? "0" : void 0, "aria-label": t.avatarAriaLabel, role: t.hasMenu ? "button" : void 0 } }, t.hasMenu ? {
    click: t.toggleMenu,
    keydown: t.toggleMenu
  } : null), [t._t("icon", function() {
    return [t.iconClass ? e("span", { staticClass: "avatar-class-icon", class: t.iconClass }) : t.isAvatarLoaded && !t.userDoesNotExist ? e("img", { attrs: { src: t.avatarUrlLoaded, srcset: t.avatarSrcSetLoaded, alt: "" } }) : t._e()];
  }), t.hasMenu && !t.menu.length ? e("NcButton", { staticClass: "action-item action-item__menutoggle", attrs: { "aria-label": t.t("Open contact menu"), type: "tertiary-no-background" }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t.contactsMenuLoading ? e("NcLoadingIcon") : e("DotsHorizontal", { attrs: { size: 20 } })];
  }, proxy: !0 }], null, !1, 2617833509) }) : t.hasMenu ? e("NcActions", { attrs: { "force-menu": "", "manual-open": "", type: "tertiary-no-background", container: t.menuContainer, open: t.contactsMenuOpenState }, scopedSlots: t._u([t.contactsMenuLoading ? { key: "icon", fn: function() {
    return [e("NcLoadingIcon")];
  }, proxy: !0 } : null], null, !0) }, t._l(t.menu, function(a, r) {
    return e("NcActionLink", { key: r, attrs: { href: a.href, icon: a.icon } }, [t._v(" " + t._s(a.text) + " ")]);
  }), 1) : t._e(), t.showUserStatusIconOnAvatar ? e("span", { staticClass: "avatardiv__user-status avatardiv__user-status--icon" }, [t._v(" " + t._s(t.userStatus.icon) + " ")]) : t.canDisplayUserStatus ? e("span", t._b({ staticClass: "avatardiv__user-status", class: "avatardiv__user-status--" + t.userStatus.status }, "span", t.userStatusRole, !1)) : t._e(), t.showInitials ? e("span", { staticClass: "avatardiv__initials-wrapper", style: t.initialsWrapperStyle }, [e("span", { staticClass: "avatardiv__initials", style: t.initialsStyle }, [t._v(" " + t._s(t.initials) + " ")])]) : t._e()], 2);
}, I = [], k = /* @__PURE__ */ b(
  C,
  D,
  I,
  !1,
  null,
  "b9bda6c2",
  null,
  null
);
const et = k.exports;
export {
  et as N,
  A as u
};
